<template>
  <v-menu
    ref="dateMenu"
    lazy
    v-model="dateMenu"
    transition="scale-transition"
    offset-y
    full-width
    :nudge-right="40"
    min-width="290px"
    :disabled="disableInput"
  >
    <v-text-field
      slot="activator"
      :label="$t(label)"
      color="blue lighten-3"
      prepend-icon="event"
      v-model="dateFormatted"
      :clearable="false"
      readonly
      :disabled="disableInput"
      required
    ></v-text-field>
    <v-spacer></v-spacer>
    <v-date-picker
      v-model="date"
      no-title
      scrollable
      @input="onDateSelected(true)"
      :locale="localeSelected"
      :disabled="disableInput"
      :allowed-dates="allowedDates"
    >
    </v-date-picker>
  </v-menu>
</template>

<script>
import store from '@/store';
import moment from 'moment';
import utilService from '@/services/utilService';

export default {
  name: 'DatePickerFormatted',
  props: {
    inputDate: Date,
    minDate: Date,
    label: String,
    disableInput: {
      type: Boolean,
      default: false,
    },
    parkingTimeZone: {
      type: String,
      default: null,
    },
  },
  computed: {
    localeSelected() {
      return store.state.langSelected.langIso;
    },
    dateFormatted() {
      return utilService
        .getMomentTimezone(this.date, this.parkingTimeZone)
        .format('L');
    },
  },
  watch: {
    inputDate(value) {
      if (value !== null) {
        this.date = utilService
          .getMomentTimezone(value, this.parkingTimeZone)
          .format('YYYY-MM-DD');
        this.onDateSelected(false);
      }
    },
    dateFormatted(value) {
      if (value === null) {
        this.$emit('on-date-selected', { date: value });
      }
    },
  },
  data() {
    return {
      dateMenu: false,
      date: null,
    };
  },
  created() {
    if (this.inputDate !== null) {
      this.date = utilService
        .getMomentTimezone(this.inputDate, this.parkingTimeZone)
        .format('YYYY-MM-DD');

      this.onDateSelected(true);
    }
  },
  methods: {
    allowedDates(val) {
      if (this.minDate) {
        return utilService
          .getMomentTimezone(this.minDate, this.parkingTimeZone)
          .startOf('day')
          .isSameOrBefore(moment(val));
      }
      return utilService
        .getMomentTimezone(new Date(), this.parkingTimeZone)
        .startOf('day')
        .isSameOrBefore(moment(val));
    },
    onDateSelected(syncDates) {
      if (syncDates) {
        this.$emit('on-date-selected', {
          date: this.date,
          syncDates: syncDates,
        });
      }
    },
    setDate() {
      this.$refs.dateMenu.save(this.date);
      this.onDateSelected(true);
    },
    setExternalDate(params) {
      this.date = utilService
        .getMomentTimezone(params.value, this.parkingTimeZone)
        .format('YYYY-MM-DD');
      this.onDateSelected(params.syncDates);
    },
  },
};
</script>
